var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpRightDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28977 8.95109L0.0909092 7.75223L6.10795 1.7295H1.53977L1.55114 0.0817757H8.95455V7.49087H7.29545L7.30682 2.92837L1.28977 8.95109Z",
    fill: "#2988F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRightDark);
export default __webpack_public_path__ + "static/media/arrow-up-right-dark.9e848155a9cb933db616ceaff59af86a.svg";
export { ForwardRef as ReactComponent };